import ApiDrivenModel from "./ApiDrivenModel";
import ChatParticipant from "./ChatParticipant";

class Chat extends ApiDrivenModel {
	getParticipant(profile_id) {
		const match = this.participants.find(participant => +participant.profile.id === +profile_id);
		if (!match) {
			return;
		}

		if (match.getClass) {
			return match;
		}

		return new ChatParticipant(match);
	}
}
Chat.ENDPOINT = "/Chat";
Chat.LOAD_PATHS = {
	associate: [
		'first_name',
		'last_name',
		'email',
		'mobile_phone'
	],
	participants: {
		'id': true,
		'last_message_read': true,
		profile: [
			'id',
			'given_name',
			'family_name',
			'email',
			'phone'
		]
	},
	account: {
		id: true,
		name: true
	},
	created_on: true,
	id: true,
	is_closed: true,
	is_resolved: true,
	last_message_body: true,
	last_message_date_time: true,
	last_message_sender_json: true,
	pinged: true,
	reviewed: true,
	status: true,
	user_defined_data_json: true,
};
Chat.SEARCH_PATHS = Chat.LOAD_PATHS;

export default Chat;
